module.exports = __webpack_public_path__ + "83cce97417ed5879fc0e5b2e130f478f.pdf";